/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SrvProceedingCourseEntryResponse
 */
export interface SrvProceedingCourseEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingCourseEntryResponse
     */
    dateUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryResponse
     */
    entryType: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryResponse
     */
    result: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryResponse
     */
    remark: string | null;
}

/**
 * Check if a given object implements the SrvProceedingCourseEntryResponse interface.
 */
export function instanceOfSrvProceedingCourseEntryResponse(value: object): value is SrvProceedingCourseEntryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dateUtc' in value) || value['dateUtc'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('remark' in value) || value['remark'] === undefined) return false;
    return true;
}

export function SrvProceedingCourseEntryResponseFromJSON(json: any): SrvProceedingCourseEntryResponse {
    return SrvProceedingCourseEntryResponseFromJSONTyped(json, false);
}

export function SrvProceedingCourseEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingCourseEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dateUtc': (new Date(json['dateUtc'])),
        'entryType': json['entryType'],
        'result': json['result'],
        'remark': json['remark'],
    };
}

export function SrvProceedingCourseEntryResponseToJSON(json: any): SrvProceedingCourseEntryResponse {
    return SrvProceedingCourseEntryResponseToJSONTyped(json, false);
}

export function SrvProceedingCourseEntryResponseToJSONTyped(value?: SrvProceedingCourseEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dateUtc': value['dateUtc'].toISOString(),
        'entryType': value['entryType'],
        'result': value['result'],
        'remark': value['remark'],
    };
}

